import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X, HandshakeIcon, LogInIcon, UserIcon } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
interface NavbarProps {
  transparent?: boolean;
}
export function Navbar({
  transparent = false
}: NavbarProps) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const {
    currentUser
  } = useAuth();
  const getDashboardLink = () => {
    if (!currentUser) return '/login';
    switch (currentUser.type) {
      case 'brand':
        return '/dashboard/brand';
      case 'organizer':
        return '/dashboard/organizer';
      case 'admin':
        return '/admin';
      default:
        return '/login';
    }
  };
  return <nav className="bg-white bg-opacity-90 backdrop-blur-sm shadow-sm border-b border-gray-100 relative z-30" data-id="element-599">
      <div className="container mx-auto px-4" data-id="element-600">
        <div className="flex justify-between items-center h-16" data-id="element-601">
          <Link to="/" className="flex items-center space-x-2 group" data-id="element-602">
            <div className="bg-blue-600 p-2 rounded-md relative overflow-hidden tech-pulse" data-id="element-603">
              <HandshakeIcon className="h-6 w-6 text-white relative z-10" data-id="element-604" />
            </div>
            <span className="text-xl font-semibold text-gray-900 group-hover:text-blue-600 transition-colors" data-id="element-605">
              SponsrAI
            </span>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-4" data-id="element-606">
            <Link to={getDashboardLink()} className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-md text-sm font-medium transition-colors flex items-center relative overflow-hidden group" data-id="element-607">
              <span className="relative z-10 flex items-center" data-id="element-608">
                {currentUser ? <>
                    <UserIcon className="h-4 w-4 mr-1" data-id="element-609" />
                    Dashboard
                  </> : <>
                    <LogInIcon className="h-4 w-4 mr-1" data-id="element-610" />
                    Login
                  </>}
              </span>
              <span className="absolute inset-0 bg-gradient-to-r from-blue-500 to-indigo-600 opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-611"></span>
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <div className="md:hidden" data-id="element-612">
            <button onClick={() => setIsMenuOpen(!isMenuOpen)} className="p-2 rounded-md text-gray-700 hover:bg-gray-100" data-id="element-613">
              {isMenuOpen ? <X className="h-6 w-6" data-id="element-614" /> : <Menu className="h-6 w-6" data-id="element-615" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMenuOpen && <div className="md:hidden bg-white bg-opacity-95 backdrop-blur-sm border-b border-gray-200" data-id="element-616">
          <div className="container mx-auto px-4 py-2 space-y-1" data-id="element-617">
            <Link to={getDashboardLink()} className="block px-3 py-2 rounded-md text-base font-medium bg-blue-600 text-white hover:bg-blue-700 transition-colors flex items-center" onClick={() => setIsMenuOpen(false)} data-id="element-618">
              {currentUser ? <>
                  <UserIcon className="h-4 w-4 mr-2" data-id="element-619" />
                  Dashboard
                </> : <>
                  <LogInIcon className="h-4 w-4 mr-2" data-id="element-620" />
                  Login
                </>}
            </Link>
          </div>
        </div>}
    </nav>;
}